import { Divider, Grid2, Typography } from "@mui/material";
import moment from "moment";
import dataConstant from "../../constants/dataConstants";
import ExpandableTypography from "./ExpandableTypography";

const ServiceScheduleDetail = ({ formData, fromReview = false }) => {
  return (
    <>
      <Typography variant="h4" color="default.main">
        Service Details
      </Typography>
      <Grid2 container spacing={2} sx={{ mb: 3, mt: 3 }}>
        <Grid2 item size={{ xs: 6, sm: 4 }}>
          <Typography variant="body2" color="default.main" mb={0.5}>
            Select your desired start date:
          </Typography>
          <Typography variant="body1" color="default.light">
            {moment(formData?.serviceDetails.startDate).format(dataConstant.dateFormatUSFormat)}
          </Typography>
        </Grid2>
        <Grid2 item size={{ xs: 6, sm: 4 }}>
          <Typography variant="body2" color="default.main" mb={0.5}>
            Caregiver Preference:
          </Typography>
          <Typography variant="body1" color="default.light">
            {formData?.serviceDetails?.caregiverPreference}
          </Typography>
        </Grid2>
        <Grid2 item size={{ xs: 6, sm: 4 }}>
          <Typography variant="body2" color="default.main" mb={0.5}>
            Special Requests:
          </Typography>
          <ExpandableTypography chunkSize={300}>
            {formData?.serviceDetails.specialRequests || "-"}
          </ExpandableTypography>
        </Grid2>
      </Grid2>
      <Typography variant="h4" color="default.main">
        Schedule: Variable and Flexible
      </Typography>
      <Typography variant="body2" color="default.main" mb={0.5} mt={3} >
        Schedule:
      </Typography>
      <Typography variant="body1" color="default.light">
        {formData?.scheduleVariableFlexible.scheduleType}
      </Typography>

      <Grid2
        container
        spacing={2}
        alignItems="center"
        sx={{ mt: 3 }}
      >
        {formData?.scheduleVariableFlexible?.dayTimes?.days?.map((day) => {
          const time = formData?.scheduleVariableFlexible?.dayTimes?.dayTimes[day];
          const formatTime = (t) =>
            t ? moment(t, "HH:mm").format("hh:mm A") : "-";
          return (
            <Grid2 item size={{ xs: 6 }} key={day}>
              <Typography variant="body2" color="default.main" mb={0.5}>
                {day}:
              </Typography>
              <Typography variant="body1" color="default.light">
                {formatTime(time?.startTime)} to {formatTime(time?.endTime)}
              </Typography>
            </Grid2>
          );
        })}
      </Grid2>
    </>
  );
};
export default ServiceScheduleDetail;
